import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins";
import "@/styles";

import WarningDialog from "./components/Dialog/WarningDialog.vue";
import EditableDisplay from "./components/Editor/EditableDisplay.vue";

import { i18n } from "@/locales/i18n";

Vue.config.productionTip = false;

// 전역 컴포넌트 등록
Vue.component("WarningDialog", WarningDialog);
Vue.component("EditableDisplay", EditableDisplay);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
